import { endpoints } from 'modules/endpoints'
import { createBasicManagers } from 'modules/utils/helpers/createBasicManagers'
import { octopusApiClient } from 'modules/utils/httpClient'
import { ListResponse } from 'types/api'
import {
  TargetSkuListRequestFilter,
  TargetSkuListRequestSorting,
  TargetSkuUpdateDTO,
  CropTargetSku,
  CropTargetSkuCreateDTO,
} from '../common/types'

// export default createBasicManagers<
//   TargetSkuListRequestFilter,
//   TargetSkuListRequestSorting,
//   CropTargetSku,
//   CropTargetSkuCreateDTO,
//   TargetSkuUpdateDTO
// >(endpoints.cropTargetSku, octopusApiClient)

const cropTargetSkuManagers = {
  ...createBasicManagers<
    TargetSkuListRequestFilter,
    TargetSkuListRequestSorting,
    CropTargetSku,
    CropTargetSkuCreateDTO,
    TargetSkuUpdateDTO
  >(endpoints.cropTargetSku, octopusApiClient),
  getList: (
    filter: TargetSkuListRequestFilter,
    sorting: TargetSkuListRequestSorting,
    page: number,
    pageSize?: number,
  ) => {
    try {
      return octopusApiClient.get<ListResponse<CropTargetSku>>(endpoints.cropTargetSku(), {
        ...filter,
        ...sorting,
        page: page,
        page_size: pageSize,
        order_by: 'territory_asc',
      })
    } catch (err) {
      console.error('List fetch error!', err)
      throw err
    }
  },
}

export default cropTargetSkuManagers
